const isSslEnabled = process.env.REACT_APP_SSL_ENABLED === "true"; // Check if SSL is enabled

// URLs based on SSL setting
const API_BASE_URL = isSslEnabled
  ? process.env.REACT_APP_API_BASE_URL_HTTPS
  : process.env.REACT_APP_API_BASE_URL_HTTP;

const ASSETS_BASE_URL = isSslEnabled
  ? process.env.REACT_APP_ASSETS_BASE_URL_HTTPS
  : process.env.REACT_APP_ASSETS_BASE_URL_HTTP;

const SERVER_BASE_URL = isSslEnabled
  ? process.env.REACT_APP_SERVER_BASE_URL_HTTPS
  : process.env.REACT_APP_SERVER_BASE_URL_HTTP;

const RSPL_LIST =
	process.env.REACT_APP_RSPL_LIST && process.env.REACT_APP_RSPL_LIST !== ""
		? JSON.parse(process.env.REACT_APP_RSPL_LIST)
		: JSON.parse('[{"key":["A"],"value":"Critical"},{"key":["B","C"],"value":"Maintainence"}]');

export { API_BASE_URL, ASSETS_BASE_URL, SERVER_BASE_URL, RSPL_LIST };
